
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/contact-us.lazy",
      function () {
        return require("private-next-pages/contact-us/contact-us.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/contact-us.lazy"])
      });
    }
  